import Wahanda from 'common/wahanda';

export const SELF_EMPLOYMENT_REPORTS_FLAG = 'THY-2440-self-employment-reports';

// The reports show what each team member earned, so both the sales report and the finance
// permission are required. view-reports-sales also keeps the Reports nav tab visible.
export const canViewSelfEmploymentReports = (): boolean =>
  Boolean(
    Wahanda.Features.isEnabled(SELF_EMPLOYMENT_REPORTS_FLAG) &&
      Wahanda.Permissions.viewReportsSales() &&
      Wahanda.Permissions.viewFinanceData(),
  );
